module.exports = __webpack_public_path__ + "static/media/smallMember.3e80b577.png";